import { useEffect, useState } from 'react';
import axios from 'axios';
import { Prod01 } from '../../constants/ActionType';
import { formatCalendarDate, formatDateTime } from '../../utils/dateFormat';
import { friendlyErrorMessage } from '../../utils/apiError';

export const DR_API = `${Prod01}/device-requests`;
export const DEVICE_TYPES = [
    { value: 'bp', label: 'BP monitor' },
    { value: 'glucometer', label: 'Glucometer' },
    { value: 'weight', label: 'Weight scale' },
    { value: 'spO2', label: 'Pulse oximeter' },
];
export const typeLabel = (t) => (DEVICE_TYPES.find((d) => d.value === t) || {}).label || t;
export const STATUS = {
    SUBMITTED: { label: 'Submitted', bg: 'primary' },
    RETURNED: { label: 'Returned to nurse', bg: 'warning' },
    APPROVED: { label: 'Approved (unsent)', bg: 'info' },
    SENT_TO_EC: { label: 'Sent to EC', bg: 'secondary' },
    IN_PROGRESS: { label: 'In progress', bg: 'secondary' },
    PARTIAL: { label: 'Partial', bg: 'warning' },
    FULFILLED: { label: 'Fulfilled', bg: 'success' },
    CANNOT_FULFIL: { label: 'Cannot fulfil', bg: 'danger' },
    CANCELLED: { label: 'Cancelled', bg: 'dark' },
};
export const STATUS_KEYS = Object.keys(STATUS);
export const EC_PENDING = 'SENT_TO_EC,IN_PROGRESS,PARTIAL';
export const NURSE_ROLES = ['HrMedical', 'HrLead'];
export const REVIEW_ROLES = ['adminStaff', 'admin'];

export const errMsg = (err) => friendlyErrorMessage(err);
export const patientLabel = (p) => (p ? `${p.lastname || ''}, ${p.firstname || ''}`.replace(/^, |, $/g, '') : '');
/** Date-only fields are stored as UTC midnight: format without shifting the day. */
// Calendar-day fields (DOB, prescribed/program dates) are stored at UTC midnight: no timezone shift.
export const fmtDate = (d) => formatCalendarDate(d);
export const fmtDateTime = (d) => formatDateTime(d);
export const toInputDate = (d) => (d ? new Date(d).toISOString().slice(0, 10) : '');

/** Role badge counts from /device-requests/badges, refreshed every minute. */
export const useDeviceRequestBadges = (enabled = true) => {
    const [badges, setBadges] = useState({});
    useEffect(() => {
        if (!enabled) return undefined;
        let alive = true;
        const load = () =>
            axios
                .get(`${DR_API}/badges`)
                .then((res) => alive && setBadges(res.data || {}))
                .catch(() => {});
        load();
        const t = setInterval(load, 60000);
        return () => {
            alive = false;
            clearInterval(t);
        };
    }, [enabled]);
    return badges;
};

export const CountBadge = ({ n, bg = 'danger', title }) =>
    n > 0 ? (
        <span className={`badge badge-pill badge-${bg} ml-1`} title={title} data-testid="dr-badge">
            {n}
        </span>
    ) : null;
